import React from 'react';
import './styles.css';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  onCancel, 
  title, 
  message, 
  confirmText = 'Yes', 
  cancelText = 'No',
  closeText = null 
}) => {
  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm(); // Wait for async operation to complete
    }
    // Don't call onClose here - let the onConfirm handler manage it
  };

  const handleCancel = async () => {
    if (onCancel) {
      await onCancel(); // Wait for async operation to complete
    } else {
      onClose(); // Only close if no custom cancel handler
    }
    // Don't call onClose here - let the onCancel handler manage it
  };

  const handleOverlayClick = () => {
    onClose();
  };

  return (
    <div className="confirm-modal-overlay" onClick={handleOverlayClick}>
      <div className="confirm-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-content">
          <div className="confirm-modal-icon">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          
          <h2 className="confirm-modal-title">{title}</h2>
          <p className="confirm-modal-message">{message}</p>
          
          <div className="confirm-modal-buttons">
            <button className="confirm-modal-btn confirm-btn" onClick={handleConfirm}>
              {confirmText}
            </button>
            <button className="confirm-modal-btn cancel-btn" onClick={handleCancel}>
              {cancelText}
            </button>
            {closeText && (
              <button className="confirm-modal-btn close-btn" onClick={handleOverlayClick}>
                {closeText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

